import { Component } from '@angular/core';
import { NgForOf, NgIf } from '@angular/common';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  standalone: true,
  imports: [NgForOf, NgIf]
})
export class FaqComponent {
  faqs = [
    {
      question: 'When should I run identity verification on a party?',
      answer: 'We suggest it be run shortly after you receive the order.',
      hasLink: false
    },
    {
      question: 'What types of transactions do I need to run an identification verification on?',
      answer: '• Hard-money transactions \n• Non-owner occupied transactions \n•	Vacant Land transactions \n• Flips or assignments of contract with more than 20% increase in price between first and second transaction. \n•	Sales for noticeably less or significantly more than the estimated value. \n•	Any transaction where there has been a recent uninsured transfer within 6 months of the date of the current transaction.',
      hasLink: false
    },
    {
      question: 'Can I run an identity verification on non-WFG transactions?',
      answer: 'Use of this platform for identity verification is only for transactions that will be written on WFG paper.',
      hasLink: false
    },
    {
      question: 'What information do I need to start an identity verification?',
      answer: '• Individual’s name \n• Individual’s email address \n• Individual’s mobile cell number',
      hasLink: false
    },
    {
      question: 'What does a recipient need to complete an identity verification?',
      answer: '• Government issued photo ID card such as a driver’s license or passport \n • A device with audio and video and a supported browser',
      hasLink: false
    },
    
    {
      question: 'What is a KBA search?',
      answer: 'Knowledge-based authentication, sometimes referred to as KBA, is a quiz of questions generated from the signer\'s personal information. KBA is often used with credential analysis for even more security.',
      hasLink: false
    },
    {
      question: 'What does the consumer need to complete the KBA?',
      answer: '• Name\n• Address\n• Date of birth\n• The last 4 digits of their Social Security number or Tax ID Number (TIN)',
      hasLink: false
    },
    {
      question: 'How does the KBA work?',
      answer: 'Questions presented during the quiz:\n\n• Will vary for each person.\n• May be about the signer or their history and may include property, vehicle, phone numbers, and several other categories.\n• May be about others with a shared property interest.\n• You have 2 minutes to answer 4 out of 5 challenge questions correctly to verify your identity.',
      hasLink: false
    },
    {
      question: 'How many KBA questions must be answered correctly to pass the KBA?',
      answer: '4 out of 5',
      hasLink: false
    },
    {
      question: 'What happens if the individual fails the KBA test? How should we proceed?',
      answer: 'If the consumer does not pass the first time, they can attempt the quiz one more time right away. If they don\'t pass on the second attempt, they receive a notification confirming the time they can try again. If the quiz is failed a third time, they are locked out for 48 hours from the time of the 1st attempt. If the individual only passes KBA after having 48 hours, it is a “Yellow Flag” that should be discussed with underwriting.',
      hasLink: false
    },
    {
      question: 'Troubleshooting the KBA portion of the identity verification',
      answer: 'If you have trouble with the knowledge-based authentication quiz, try the following tips:\n• Check your name, date of birth, address, and Social Security number for errors.\n• Make sure you are using your full legal name.\n• If you recently changed your name, try your former name.\n• If you recently moved, try using your former U.S. address.\nOccasionally, someone with a valid Social Security number lacks enough records to generate the minimum number of required verification questions (e.g., credit history, property records, vehicle registrations, etc.).\nSometimes this happens if:\n• There is not enough personal data to generate the minimum number of required questions.\n• All available knowledge-based questions were asked.',
      hasLink: false
    },
    {
      question: 'What is a credential analysis plus selfie?',
      answer: 'Credential analysis compares the ID and the person on camera. Selfie comparison utilizes a real-time selfie photo compared with the photo ID.',
      hasLink: false
    },
    {
      question: 'How does the credential analysis work?',
      answer: 'Credential analysis is presented to users after they pass knowledge-based authentication. The platform runs an automated analysis of the primary credential provided by each signer to determine if the ID they submitted appears to be valid. Multiple factors contribute to the system\'s algorithm to confirm an ID is valid.\n\nBe sure the consumer uses their own individual email address for their account. The platform only allows one identity per email address.',
      hasLink: false
    },
    {
      question: 'How do I add the report to the transaction in my closing software?',
      answer: 'Download a copy of the report from the platform and add it to your electronic and/or paper transaction file. This report must be made a part of your transaction file.',
      hasLink: false
    },
    {
      question: 'How do I save an Identity Verification report?',
      answer: 'Click "View Report", then click "Download Report" to download the report in PDF file format.',
      hasLink: false
    },
    {
      question: 'Can the identity verification invitation be sent more than once?',
      answer: 'Yes, invitation can be resent using the Resend Email and Resend SMS options.',
      hasLink: false
    },
    {
      question: 'Can the identity verification be sent only by text message if the client does not provide an email address?',
      answer: 'Email address is required to create an Identity verification transaction.',
      hasLink: false
    },
    {
      question: 'Can the identity verification be sent only via email if the consumer does not provide a cell number?',
      answer: 'Yes, phone number is optional.',
      hasLink: false
    },
    {
      question: 'Should I run an identity verification on all parties to a transaction?',
      answer: 'You should run the seller, or signatory for a seller entity (LLC, Corp or trust) in every instance.  The buyer needs only be run if (a) they are executing a mortgage or deed of trust; and (b) it is flip or assignments of contract with more than 20% increase in price between first and second transaction. Borrowers may need to be included, especially a cash-out refinance transaction.',
      hasLink: false
    },
    {
      question: 'What happens if the consumer passes the KBA and credential analysis plus selfie, but the IP address shows as outside of the country?',
      answer: 'This error can be caused by a VPN – Virtual Private Network. So the best advice is to have the customer turn off VPNs before the proofing begins. \n\n Second, gather more information from the customer. Where are they located? Is the computer using a VPN? \n\n Then contact your WFG underwriter to discuss how to proceed.',
      hasLink: false
    },
    {
      question: 'What happens if the individual fails the credential analysis and selfie, but passes the KBA?',
      answer: 'Download the report of the identity check and then call your WFG Underwriter to discuss how to proceed.',
      hasLink: false
    },
    {
      question: 'If the consumer fails the identity verification and comes back with a high alert, who should be notified?',
      answer: 'Download the report of the identity check and then call your WFG Underwriter to discuss how to proceed.',
      hasLink: false
    },
    {
      question: 'If a consumer passes the identity verification but ends up being a fraudster, who do we need to report the transaction to?',
      answer: 'Your manager, WFG at claims@wfgtitle.com, local law enforcement, and <a href="https://www.ic3.gov" target="_blank" class="text-blue-600 hover:text-blue-800 underline">www.ic3.gov</a>.',
      hasLink: true
    }
  ];
  expandedIndexes: Set<number> = new Set();

  toggleCard(index: number) {
    if (this.expandedIndexes.has(index)) {
      this.expandedIndexes.delete(index);
    } else {
      this.expandedIndexes.add(index);
    }
  }
}